import React,{useState, useEffect} from 'react';
import { ResizeObserver, install } from 'resize-observer';
import { formStateStore } from '../../Redux/Store/store';
import { useSelector } from '../../Redux';
import ELEMENT from '../../UI/BasicFormControls/ELEMENT';
import ELEMENTS from '../../UI/BasicFormControls/ELEMENTS';
import { useMediaQuery } from '@material-ui/core';
import { getFormJsonFromStore, getTempCanWidth } from '../IFormDesignerLayout/IFormDesignerLogic';

function useElementWidth(element, previewmode = false) {
    const [width, setWidth] = useState(null);

    // function getReduxContexts(containerId)
    //     {
    //         const state=formStateStore.getState();
    //         if(containerId===undefined){
    //             containerId=state.containerInfo.containerId;
    //         }
    //         return (state.data.find(json => json.key === containerId))?.contexts;
    //     }
   
    // const {tempCanWidth}= getReduxContexts();
    // if(previewmode && false){
    //     // ...
    //     if(element !== null)
    //         element =document.getElementById(element);
    //     else{
    //         element =document.getElementById("canvasId");
    //     }
    
    //     // if (!window.ResizeObserver) install();
    
    //     // let resizeObserver=new ResizeObserver((()=>{
           
    //         if(element && tempCanWidth){
    //             // const  elementWidthTemp = element.getBoundingClientRect().width;
    //             setWidth(tempCanWidth)
    //         }
    //     // }));
    // //    resizeObserver.observe(element)
      
    //     return width;
    // }
    // else{
    //     return width
    // }
  }

  function runAfterFramePaint(callback) {
    requestAnimationFrame(() => {
        const messageChannel = new MessageChannel();

        messageChannel.port1.onmessage = callback;
        messageChannel.port2.postMessage(undefined);
    });
  }

  const useMarkFramePaint = ({ markName, enabled }) => {
    useEffect(() => {
        /**
         * Only perform the log when the calling component has signaled it is
         * ready to log a meaningful visual update.
         */
        if (!enabled) {
            return;
        }

        // Queues a requestAnimationFrame and onmessage
        runAfterFramePaint(() => {
            // Set a performance mark shortly after the frame has been produced.
            performance.mark(markName);
            console.log(document.getElementById(markName));
            if(window.formPainted)  
              window.formPainted();
        });
    }, [markName, enabled])
}

  const GetSelector = (keyName) => {
  const dataState = useSelector((state) => state[keyName]);
  return dataState;
}

const GetExactDevice = () => {
  const formJSON = getFormJsonFromStore();
  const tempCanWidth = getTempCanWidth();
  let isDesktop = false, isTablet = false, isMobile = false;
  if(tempCanWidth <= 0) 
    isDesktop = true;
  else if(tempCanWidth >= parseInt(formJSON?.style?.Breakpoint?.Desktop?.StartValue || 1024)) 
    isDesktop = true;
  else if(tempCanWidth < parseInt(formJSON?.style?.Breakpoint?.Tab?.EndValue || 1024) && tempCanWidth >= parseInt(formJSON?.style?.Breakpoint?.Tab?.StartValue || 480))
    isTablet = true;
  else if(tempCanWidth < parseInt(formJSON?.style?.Breakpoint?.Mobile?.EndValue || 480))
    isMobile = true;

  return {isDesktop, isTablet,isMobile};
}

// Component mapping
const elementMap = {
  ELEMENT,
  ELEMENTS
};

const returnElement = (props,data,component = "ELEMENT") => {
  const Component = elementMap[component] || null;
  return(
    <Component
      {...props}
      data={data}
    />
  );
}

  
const GetStateFromData = (containerId,key="data") => {
  const dataState = GetSelector(key);
  const containerInfo = GetSelector("containerInfo")
  if(dataState) {
    const index= dataState.findIndex(json => json.key === (containerId || containerInfo.containerId));
    if (key === "data")
    return {
      contexts: dataState[index]?.contexts,
      gdtoken: dataState[index]?.gdtoken,
      witoken: dataState[index]?.witoken,
      generalData:dataState[index]?.generalData,
      formstate: dataState[index]?.formstate,
      routeJourneySelectionPage: dataState[index]?.routeJourneySelectionPage,
      wizard_stage: dataState[index]?.wizard_stage,
      isWorkItem: dataState[index]?.isWorkItem,
      pid: dataState[index]?.pid,
      formMataData: dataState[index]?.formMataData,
      gridStates: dataState[index]?.gridStates, 
    }
    else if(key === "data2"){
      return { gridStates: dataState[index]?.gridStates};
    }
    else if(key === "marvinData"){
      return { marvinStates: dataState[index]?.marvinStates};
    }
  }
  return dataState;
}

const GetState = (...params) => {
  const outputArr = {}; 
  params.forEach((keyName) => {
    const dataState = GetSelector(keyName);
    outputArr[keyName] = dataState;
  })

  return outputArr;
}

const MediaDevice = () => {
  const isDesktop = useMediaQuery("(min-width: 1025px )");
  const isTablet = useMediaQuery("(max-width: 1024px) and (min-width: 481px)");
  const isMobile = useMediaQuery("(max-width: 480px)");
  return {isDesktop, isTablet,isMobile};
}

const GetDesignerState = (param,previewmode) => {
  if(!previewmode) 
    return GetSelector(param);
  return "";
}

export {MediaDevice,useElementWidth,GetState, GetStateFromData, returnElement,GetDesignerState, useMarkFramePaint, runAfterFramePaint, GetExactDevice};
